import { Link } from 'react-router';

import { PageContainer } from '@shared';

import { useAuth } from '@/features/auth/useAuth';
import { displayName } from '@/features/auth/user-display';
import { useTranslations } from '@/i18n/client';

export function HomePage() {
  const t = useTranslations('common.home');
  const { user } = useAuth();
  const name = displayName(user);

  return (
    <PageContainer className="md-dashboard-page max-sm:w-full">
      <div className="mb-10 max-sm:mb-6">
        <h1 className="mb-2 text-[2rem] max-sm:text-[1.7rem] max-sm:wrap-anywhere">
          {name ? t('welcomeUser', { name }) : t('welcome')}
        </h1>
        <p className="m-0 max-w-full text-[1.0625rem] leading-[1.4] text-[var(--zs-muted)] max-sm:text-base">
          {t('description')}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-8 max-sm:grid-cols-1 max-sm:gap-4">
        <div className="md-dashboard__card flex flex-col gap-4 p-10 max-sm:gap-3 max-sm:p-5">
          <h2 className="m-0 text-2xl max-sm:text-xl">{t('newCaseTitle')}</h2>
          <p className="m-0 flex-1 text-base leading-[1.6] text-[var(--zs-muted)]">
            {t('newCaseDescription')}
          </p>
          <Link
            to="/cases/new"
            className="zs-button mt-2 self-start max-sm:mt-1 max-sm:w-full max-sm:self-stretch"
          >
            {t('newCaseAction')}
          </Link>
        </div>

        <div className="md-dashboard__card flex flex-col gap-4 p-10 max-sm:gap-3 max-sm:p-5">
          <h2 className="m-0 text-2xl max-sm:text-xl">{t('ordersTitle')}</h2>
          <p className="m-0 flex-1 text-base leading-[1.6] text-[var(--zs-muted)]">
            {t('ordersDescription')}
          </p>
          <Link
            to="/cases"
            className="zs-button mt-2 self-start max-sm:mt-1 max-sm:w-full max-sm:self-stretch"
          >
            {t('ordersAction')}
          </Link>
        </div>
      </div>
    </PageContainer>
  );
}
